<template>
  <div class="ai-msg" :class="isUser ? 'is-user' : 'is-ai'">
    <div class="ai-msg-avatar">
      <i :class="isUser ? 'el-icon-user' : 'el-icon-cpu'"></i>
    </div>
    <div class="ai-msg-body">
      <div v-if="message.timestamp" class="ai-msg-time">{{ message.timestamp }}</div>
      <div class="ai-msg-bubble" :class="{ 'is-error': message.error }">
        <span v-if="message.pending" class="ai-typing">
          <i></i><i></i><i></i>
        </span>
        <template v-else>{{ message.content }}</template>
      </div>
      <!-- 发送失败的重发入口：沿用同一 sessionId，用户不必重新输入 -->
      <button
        v-if="message.error"
        type="button"
        class="ai-msg-retry"
        @click="$emit('resend', message)"
      >
        <i class="el-icon-refresh-right"></i>
        重试
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "MessageItem",
  props: {
    message: { type: Object, required: true },
  },
  computed: {
    isUser() {
      return this.message.role === "user";
    },
  },
};
</script>

<style scoped>
.ai-msg {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.ai-msg.is-user {
  flex-direction: row-reverse;
}

.ai-msg-avatar {
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f3f5;
  color: #4e5969;
  font-size: 16px;
}

.ai-msg.is-ai .ai-msg-avatar {
  background: #e5f0ff;
  color: #409eff;
}

.ai-msg-body {
  max-width: 76%;
  display: flex;
  flex-direction: column;
}

.ai-msg.is-user .ai-msg-body {
  align-items: flex-end;
}

.ai-msg-time {
  font-size: 12px;
  color: #86909c;
  margin-bottom: 4px;
}

.ai-msg-bubble {
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.7;
  color: #1d2129;
  background: #f7f8fa;
  white-space: pre-wrap;
  word-break: break-word;
}

.ai-msg.is-user .ai-msg-bubble {
  background: #e5f0ff;
}

.ai-msg-bubble.is-error {
  background: #fef0f0;
  color: #f56c6c;
}

/* 失败后的恢复手段，刻意做得比气泡轻：不抢主操作视觉 */
.ai-msg-retry {
  align-self: flex-start;
  margin-top: 6px;
  padding: 2px 10px;
  font-size: 12px;
  line-height: 18px;
  font-family: inherit;
  color: #f56c6c;
  background: transparent;
  border: 1px solid #fbc4c4;
  border-radius: 4px;
  cursor: pointer;
}

.ai-msg-retry:hover {
  background: #fef0f0;
}

/* 「正在输入…」三点动画 */
.ai-typing {
  display: inline-flex;
  gap: 4px;
  align-items: center;
  height: 20px;
}

.ai-typing i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #c9cdd4;
  animation: ai-blink 1.2s infinite ease-in-out;
}

.ai-typing i:nth-child(2) {
  animation-delay: 0.2s;
}

.ai-typing i:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes ai-blink {
  0%,
  80%,
  100% {
    opacity: 0.3;
  }
  40% {
    opacity: 1;
  }
}
</style>
